import { render } from "./FooterComponent.vue?vue&type=template&id=4dde36a0"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=4dde36a0&lang=css"

import exportComponent from "/home/webcoom/Documents/www/esim-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__